import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { setupAuthInterceptor } from "../hooks/useAuthInterceptor";

export const AuthInterceptorSetup = () => {
  const { getAccessTokenSilently } = useAuth0();

  React.useEffect(() => {
    const cleanup = setupAuthInterceptor(getAccessTokenSilently);
    return () => {
      cleanup();
    };
  }, [getAccessTokenSilently]);

  return null;
};
